import React, { useState, useEffect} from 'react';
import {IconX, IconArrowLeft} from '@tabler/icons-react';
import Spinner from '@/components/loading/Spinner';
import { baseURL } from '@/store/constant';
const UploadFileModal = ({isOpen, onClose, tags, setTags, closeKnowledgeModal, flowData, setFlowData }) => {
	const [isUpload, setIsUpload] = useState(true)
	const [isLoading, setIsLoading] = useState(false)
	const [tableName, setTableName] = useState('')
	const [file, setFile] = useState<any>([])

	if (!isOpen) 
		return null;

    const handleFileChange = (e) => {
		const file = e.target.files[0];
		setFile(file);
	
		if (file) {
			// Update the table name
			const updatedTableName = file.name.replace(/\./g, '_');
			setTableName(updatedTableName);
			setIsUpload(false);
		}
	};
	
    
    const onUpload = async () => {
		setIsLoading(true);
	
		try {
			// Assume `file` is defined and available
			const formData = new FormData();
			formData.append('file', file);
	
			// Upload file
			const response = await fetch(`${baseURL}/api/upload`, {
				method: 'POST',
				body: formData,
			});
	
			if (!response.ok) {
				throw new Error('File upload failed');
			}
	
			const result: any = await response.json();
			const newTag = {
				id: result.id,
				name: result.name,
				inputName: tableName,
				url: result.url // add the URL of the uploaded file
			};

			// Check if the file type is JSON
			if (file.type === "application/json") {
				const reader = new FileReader();
	
				reader.onload = (event: any) => {
					try {
						const jsonData = JSON.parse(event.target.result);
						setFlowData({ name: result.name, flow_data: jsonData });
						// You can manage the jsonData here (e.g., set it to state)
					} catch (error) {
						console.error("Error parsing JSON:", error);
					}
				};
	
				reader.readAsText(file);
			} else {
				console.error("Please upload a valid JSON file.");
			}
	
			setTags([...tags, newTag]);
			setIsUpload(false);
			onClose();
			closeKnowledgeModal();
		} catch (error) {
			console.error('Error uploading file:', error);
			// Handle error (e.g., show an error message)
		} finally {
			setTimeout(()=>{
				setIsLoading(false);
			}, 2000)
		}
	};
	


   


	return (
		<div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
			<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
			<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
				<div className="flex h-screen items-center justify-center text-center sm:items-center sm:p-0">
					<div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl    ">
						<button className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
							onClick={onClose}>
							<IconX size={24}/>
						</button>
						<div className="px-4 pb-4  sm:p-6 sm:pb-4">
							<div className='flex-wrap'>
								<h2 className="text-lg font-semibold">Import data from your files</h2>
								<p>Upload CSV, Excel, PDF or audio files. For media files like PDF or audio, we will automatically extract text.</p>
							</div>

							<div className='p-4 mt-6  bg-gray-50'>
								<label htmlFor="table_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name your table</label>
								<input type="text" className="border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-96 p-2.5 focus:outline-none focus:border-2" placeholder="Enter Name..."
                                id="table_name"
                                value={tableName}
                                onChange={(e) => setTableName(e.target.value)}
                                required/>

							</div>

							<p className='mt-6 mb-2'>Upload your file
							</p>
							<div className='w-full border-2 border-gray-300 border-dashed '>
								<label htmlFor="uploadFile1" className="bg-white text-gray-500 font-semibold text-base rounded max-w-md h-52 flex flex-col items-center justify-center cursor-pointer  mx-auto font-[sans-serif]">
									<svg xmlns="http://www.w3.org/2000/svg" className="w-11 mb-2 fill-gray-500" viewBox="0 0 32 32">
										<path d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z" data-original="#000000"/>
										<path d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z" data-original="#000000"/>
									</svg>
									Upload file

									<input type="file" id='uploadFile1' className="hidden" onChange={handleFileChange}/>
									<p className="text-xs font-medium text-gray-400 mt-2">PNG, JPG SVG, WEBP, and GIF are Allowed.</p>
								</label>
							</div>

						</div>
						<div className="bg-gray-50 px-4 py-3 flex flex-row-reverse justify-between px-6">
							<button type="button"
								className={
									`w-full justify-center rounded-md px-2 py-1 text-sm font-semibold shadow-sm sm:w-auto ring-1 ring-inset ${
										isUpload ? "bg-gray-200 cursor-not-allowed ring-gray-300 text-gray-500" : "bg-white text-black hover:bg-gray-200 ring-gray-300"
									}`
								}
								disabled={isUpload}
                                onClick={onUpload}
                                >
                               {isLoading && <Spinner size={6} color="text-black" /> }
								Upload data table
							</button>
							<button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-200 sm:mt-0 sm:w-auto" onClick={onClose}><IconArrowLeft stroke={1.5}/>
								Back</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const WebsiteModal = ({isOpen, onClose, tags, setTags, closeKnowledgeModal}) => {
	if (!isOpen) 
		return null;
	
    const [url, setUrl] = useState('');
    const [type, setType] = useState('HTML');
    const [tableName, setTableName] = useState('');
	const [loadingOpen, setLoadingOpen] = useState(false);

    const handleUrlChange = (e) => {
        const inputUrl = e.target.value;
        setUrl(inputUrl);

        // Extract domain name from URL
        const url = new URL(inputUrl);

        // Extract the domain and path
        const domain = url.hostname;
        const path = url.pathname;

        // Format the domain and path
        const formattedDomain = domain
            .replace(/^www\./, '') // Remove 'www.' if present
            .replace(/\./g, '_')  // Replace '.' with '_'
            .replace(/-/g, '_');  // Replace '-' with '_'

        // Format the path
        const formattedPath = path
            .split('/')  // Split the path into segments
            .filter(Boolean)  // Remove empty segments
            .map(segment => segment.replace(/-/g, '_'))  // Replace '-' with '_'
            .join('_'); // Join segments with '_'


        const formattedName = `${formattedDomain}${formattedPath}`;
        setTableName(formattedName);
    };

	


    const onWebsite = () =>{
		// onClose()
     setLoadingOpen(true);
	
	// 	fetch(url)
    // .then(response => {
    //     if (type === 'HTML') {
    //         return response.text(); // for HTML content
    //     } else if (type === 'TEXT') {
    //         return response.text(); // for plain text content
    //     } else {
    //         throw new Error('Unknown type');
    //     }
    // })
    // .then(data => {
    //     console.log(data);
    // })
    // .catch(error => {
    //     console.error('Error:', error);
    // });


        if (tableName) {
            const newTag = {
                id: tags.length + 1,
                name: tableName,
				url: url,
				inputName: tableName
            };
            setTags([...tags, newTag]);
            
			setTimeout(() => {
				setLoadingOpen(false);
				onClose();
				closeKnowledgeModal();	
            }, 3000);
        }

    }


	return (
		<div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
			<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
			<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
				<div className="flex h-screen items-center justify-center text-center sm:items-center sm:p-0">
					<div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl    ">
						<button className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
							onClick={onClose}>
							<IconX size={24}/>
						</button>
						<div className="px-4 pb-4  sm:p-6 sm:pb-4">
							<div className='flex-wrap'>
								<h2 className="text-lg font-semibold">Import content from website</h2>
								<p>Import data from external sources as knowledge..</p>
							</div>

							<div className='p-4 mt-6  bg-gray-50'>
								<label htmlFor="table_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name your table</label>
								<input type="text" className="border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-96 p-2.5 focus:outline-none focus:border-2" placeholder="Enter Name..."
                                id="table_name"
                                value={tableName}
                                onChange={(e) => setTableName(e.target.value)}
                                required/>

							</div>

							<div className="space-y-4 w-full">
                            <label htmlFor="website-url" className="block text-sm font-medium text-gray-900 dark:text-white">Website URL</label>
                            <input 
                                id="website-url"
                                type="url"
                                className="w-full ring-1 ring-inset ring-gray-300 rounded-md p-2 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:border-2" 
                                placeholder="http://arrowflow.com" 
                                value={url}
                                onChange={handleUrlChange}
                            />

                            <label htmlFor="content-type" className="block text-sm font-medium text-gray-900 dark:text-white">Types of content to import</label>
                            <select 
                                id="content-type" 
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-96 p-2 focus:outline-none focus:border-2" 
								value={type}
								onChange={(e)=> setType(e.target.value) }
                            >
                                <option value="HTML" selected>HTML</option>
                                <option value="TEXT">Text</option>
                            </select>
                            </div>

						</div>
						<div className="bg-gray-50 px-4 py-3 flex flex-row-reverse justify-between px-6">
							<button type="button"
								className="w-full justify-center rounded-md px-2 py-1 text-sm font-semibold shadow-sm sm:w-auto ring-1 ring-inset  bg-white text-black hover:bg-gray-200 ring-gray-300"
                                onClick={onWebsite}
                                >
								continue
							</button>
							<button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-200 sm:mt-0 sm:w-auto" onClick={onClose}><IconArrowLeft stroke={1.5}/>
								Back</button>
						</div>
					</div>
				</div>
			</div>
			<Loading isOpen={loadingOpen} onclose={() => setLoadingOpen(false)} />
		</div>

	);
};

const ThirdPartyModal = ({isOpen, onClose, tags, setTags, closeKnowledgeModal}) => {
	if (!isOpen) 
		return null;
	

	return (
		<div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
			<div className="fixed inset-0 bg-gray-500 bg-opacity-100 transition-opacity" aria-hidden="true"></div>
			<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
				<div className="flex h-screen items-center justify-center p-4 text-center sm:items-center sm:p-0">
					<div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl p-6">
						<button className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
							onClick={onClose}>
							<IconX size={24}/>
						</button>
						<div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
							<h2 className="text-lg font-semibold">Third Party Modal</h2>
							<p>Choose from our library of loader integrations.</p>
						</div>
					</div>
				</div>
			</div>
		
		</div>
	);
};


const Loading = ({onclose, isOpen }) =>{

	if (!isOpen) 
		return null;

	return(
		<div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
		<div className="fixed inset-0 bg-gray-500 bg-opacity-100 transition-opacity" aria-hidden="true"></div>
		<div className="fixed inset-0 z-10 flex items-center justify-center">
		<div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all w-6/12 flex flex-col items-center justify-center">
		<img src="/img/loading.gif" alt="Loading" className="mx-auto my-4" />
		<p className="text-center px-16 pb-4">
			Importing website. This may take up to 30 minutes depending on the size of your website. Feel free to close this message - this will continue to run in the background.
		</p>
		</div>
		</div>
		</div>
	)
}


export {
	UploadFileModal,
	WebsiteModal,
	ThirdPartyModal
};
